var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shell-nav container" }, [
    _c("div", { staticClass: "shell-nav__bar" }, [
      _c("div", { staticClass: "shell-nav__brand" }, [
        _c("div", { staticClass: "shell-nav__logo-wrap" }, [
          _vm.logoPath
            ? _c("img", {
                staticClass: "shell-nav__logo",
                attrs: { src: _vm.logoPath, alt: "logo" },
              })
            : _c("img", {
                staticClass: "shell-nav__mark",
                attrs: {
                  src: require("@/assets/portal-mark.svg"),
                  alt: "Portal",
                },
              }),
        ]),
        _c("div", { staticClass: "shell-nav__brand-copy d-none d-sm-block" }, [
          _c("div", { staticClass: "shell-nav__product" }, [
            _vm._v(_vm._s(_vm.$t("pages.login.description"))),
          ]),
        ]),
      ]),
      _c(
        "nav",
        {
          staticClass: "shell-nav__links d-none d-lg-flex",
          attrs: { "aria-label": "Main" },
        },
        [
          _c(
            "ul",
            { staticClass: "nav shell-nav__menu" },
            [
              _c(
                "li",
                { staticClass: "nav-item main-bottom-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: { name: "dashboard" }, exact: "" },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-home",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("pages.dashboard.title")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.isCurrentRoleEmployee
                ? [
                    _vm.activeEmployeePayrolls
                      ? _c(
                          "li",
                          { staticClass: "nav-item main-bottom-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nav-link",
                                attrs: { to: { name: "payroll" } },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-file-invoice-dollar",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("pages.payroll.title")) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.activeEmployeePermissions
                      ? _c(
                          "li",
                          { staticClass: "nav-item main-bottom-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nav-link",
                                attrs: { to: { name: "permission" } },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-clipboard-list",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("pages.permission.title")) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.activeEmployeePlanning
                      ? _c(
                          "li",
                          { staticClass: "nav-item main-bottom-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nav-link",
                                attrs: { to: { name: "planning" } },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-calendar-week",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("pages.planning.title")) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showNethinkingTraining
                      ? _c(
                          "li",
                          { staticClass: "nav-item main-bottom-menu-item" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: { disabled: _vm.openingTraining },
                                attrs: {
                                  href: "#",
                                  "aria-busy": _vm.openingTraining
                                    ? "true"
                                    : "false",
                                  "aria-disabled": _vm.openingTraining
                                    ? "true"
                                    : "false",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.openTraining.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm.openingTraining
                                  ? _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-sm mr-1",
                                      attrs: {
                                        role: "status",
                                        "aria-hidden": "true",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass: "fas fa-graduation-cap",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("pages.navigation.training")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : [
                    _c(
                      "li",
                      { staticClass: "nav-item main-bottom-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: { to: { name: "payroll-employees" } },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-file-invoice-dollar",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("pages.payroll-employees.title")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "li",
                      { staticClass: "nav-item main-bottom-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: { to: { name: "planing-team" } },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-users",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("pages.planing-team.title")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "shell-nav__actions" },
        [
          _c(
            "div",
            { staticClass: "shell-nav__notify" },
            [_c("notification-component")],
            1
          ),
          _c("theme-toggle-component"),
          _c("profile-user-menu"),
          _c(
            "a",
            {
              staticClass: "shell-nav__logout",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.logout.apply(null, arguments)
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-sign-out-alt" }),
              _c("span", { staticClass: "d-none d-xl-inline" }, [
                _vm._v(_vm._s(_vm.$t("pages.navigation.sign_out"))),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
    _c(
      "nav",
      {
        staticClass: "shell-nav__links shell-nav__links--mobile d-lg-none",
        attrs: { "aria-label": "Main mobile" },
      },
      [
        _c(
          "ul",
          { staticClass: "nav shell-nav__menu" },
          [
            _c(
              "li",
              { staticClass: "nav-item main-bottom-menu-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "nav-link",
                    attrs: { to: { name: "dashboard" }, exact: "" },
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-home",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("pages.dashboard.title")) + " "),
                  ]
                ),
              ],
              1
            ),
            _vm.isCurrentRoleEmployee
              ? [
                  _vm.activeEmployeePayrolls
                    ? _c(
                        "li",
                        { staticClass: "nav-item main-bottom-menu-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: { name: "payroll" } },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-file-invoice-dollar",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pages.payroll.title")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.activeEmployeePermissions
                    ? _c(
                        "li",
                        { staticClass: "nav-item main-bottom-menu-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: { name: "permission" } },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-clipboard-list",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pages.permission.title")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.activeEmployeePlanning
                    ? _c(
                        "li",
                        { staticClass: "nav-item main-bottom-menu-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: { name: "planning" } },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-calendar-week",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pages.planning.title")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showNethinkingTraining
                    ? _c(
                        "li",
                        { staticClass: "nav-item main-bottom-menu-item" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              class: { disabled: _vm.openingTraining },
                              attrs: {
                                href: "#",
                                "aria-busy": _vm.openingTraining
                                  ? "true"
                                  : "false",
                                "aria-disabled": _vm.openingTraining
                                  ? "true"
                                  : "false",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openTraining.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm.openingTraining
                                ? _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-sm mr-1",
                                    attrs: {
                                      role: "status",
                                      "aria-hidden": "true",
                                    },
                                  })
                                : _c("i", {
                                    staticClass: "fas fa-graduation-cap",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pages.navigation.training")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : [
                  _c(
                    "li",
                    { staticClass: "nav-item main-bottom-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: { to: { name: "payroll-employees" } },
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-file-invoice-dollar",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("pages.payroll-employees.title")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    { staticClass: "nav-item main-bottom-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: { to: { name: "planing-team" } },
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-users",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("pages.planing-team.title")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }